import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getScreenWidth, getScreenIsReady, getIsMobileScreenWidth } from 'selectors/screen'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import { SAArtwork } from 'types/Artwork'
import { getUserID, isSessionSet } from 'selectors/user/session'
import { getHitsResults, getQueryId, getSortIndice } from '../selectors/algolia'
import { getArtistName } from '../selectors/header'
import { getSelectedFacetsCount } from '../selectors/facets'
import { getIsUsersArtworksAccount } from '../selectors/app'
import { getPageIsReady } from 'selectors/page'

const mapStateToProps = createStructuredSelector({
  artworks: getHitsResults,
  isReady: getScreenIsReady,
  isSet: isSessionSet,
  screenWidth: getScreenWidth,
  artistName: getArtistName,
  facetsCount: getSelectedFacetsCount,
  isUsersArtworksAccount: getIsUsersArtworksAccount,
  algoliaIndice: getSortIndice,
  algoliaQueryId: getQueryId,
  algoliaUserToken: getAlgoliaUserToken,
  isMobileScreen: getIsMobileScreenWidth,
  isScreenReady: getScreenIsReady,
  userID: getUserID,
  isPageReady: getPageIsReady,
})

export type ConnectorProps = {
  artworks: ReadonlyArray<SAArtwork>
  isReady: boolean
  isSet: boolean
  screenWidth: number
  artistName: string
  facetsCount: number
  isUsersArtworksAccount: boolean
  algoliaIndice: string
  algoliaQueryId: string
  algoliaUserToken: string
  isMobileScreen: boolean
  isScreenReady: boolean
  userID: number
  isPageReady: boolean
}
export default connect(mapStateToProps)
